import{jsx as _jsx}from"react/jsx-runtime";export const Separator=()=>{return _jsx("hr",{className:"c-separator"})};